import React from "react";
import SvgIcn from "../../data/IconCompo";

const DashboardStats = ({ users, items, activeView, setActiveView }) => {
  return (
    <>
    <div className="stats-item-title">
      <div
        className={`section-button ${activeView === "users" ? "active" : ""}`}
        onClick={() => setActiveView("users")}
        style={{ cursor: "pointer" }}
      >
        <SvgIcn name="user_2" />
        <p>
          USERS<span>{users.length}</span>
        </p>
      </div>
      <div
        className={`section-button ${activeView === "items" ? "active" : ""}`}
        onClick={() => setActiveView("items")}
        style={{ cursor: "pointer" }}
      >
        <SvgIcn name="services_bb" />
        <p>
          ITEMS<span>{items.length}</span>
        </p>
      </div>

    </div>

    <div className="stats-item-title">
      <div className="stats-item">
        <SvgIcn name="hand4" />
        <div className="stats-header">
          <span>CLICKS</span>
          <div className="stats-value">
            {items.reduce((sum, item) => sum + (item.clicks || 0), 0)}
          </div>
        </div>
      </div>

      <div className="stats-item">
        <SvgIcn name="heart" />
        <div className="stats-header">
          <span>FAVS</span>
          <div className="stats-value">
            {items.reduce((sum, item) => sum + (item.likes || 0), 0)}
          </div>
        </div>
      </div>
    </div>

    </>
  );
};

export default DashboardStats;
